import { render, staticRenderFns } from "./relatedgoods.vue?vue&type=template&id=85f8433c&scoped=true"
import script from "./relatedgoods.vue?vue&type=script&lang=js"
export * from "./relatedgoods.vue?vue&type=script&lang=js"
import style0 from "./relatedgoods.vue?vue&type=style&index=0&id=85f8433c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f8433c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85f8433c')) {
      api.createRecord('85f8433c', component.options)
    } else {
      api.reload('85f8433c', component.options)
    }
    module.hot.accept("./relatedgoods.vue?vue&type=template&id=85f8433c&scoped=true", function () {
      api.rerender('85f8433c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/commissionmanagement/relatedgoods.vue"
export default component.exports